import type { PreviewResultsBarProps } from './types';

/**
 * shouldDisablePreviewButton
 * helper function that defines whether or not the the preview button should be disabled.
 * Only used in the PreviewResultsBar component, but factored out for easier testing.
 */
export const shouldDisablePreviewButton = ({
  disabled,
  hasDynamicFields,
  orderByDynamicLocation,
  usesSmartRecos,
  previewIdentifier,
}: Pick<
  PreviewResultsBarProps,
  | 'disabled'
  | 'hasDynamicFields'
  | 'orderByDynamicLocation'
  | 'previewIdentifier'
  | 'usesSmartRecos'
>) => {
  const hasOrderByDynamicLocation = orderByDynamicLocation !== undefined;
  const isOrderByDynamicLocationEmpty = !orderByDynamicLocation;

  if (disabled) {
    return true;
  } else if (hasDynamicFields || hasOrderByDynamicLocation) {
    if (previewIdentifier?.length) {
      return hasOrderByDynamicLocation ? isOrderByDynamicLocationEmpty : false;
    }
    return true;
  } else if (usesSmartRecos) {
    return !previewIdentifier?.length;
  }

  return false;
};
